import {
  GET_SAVINGS_LIST_START,
  GET_SAVINGS_LIST_SUCCESS,
  GET_SAVINGS_LIST_ERROR,
} from 'constants/action-types/savings';
import apiAction from 'helpers/apiAction';

export default data => dispatch =>
  dispatch(
    apiAction({
      method: 'post',
      url: '/GetSavingsList',
      data,
      onStart: () => dispatch =>
        dispatch({
          type: GET_SAVINGS_LIST_START,
        }),
      onSuccess: data => dispatch => {
        return dispatch({
          type: GET_SAVINGS_LIST_SUCCESS,
          payload: {
            data: data,
          },
        });
      },
      onFailure: error => dispatch => {
        return dispatch({
          type: GET_SAVINGS_LIST_ERROR,
          payload: {
            error: error[0],
          },
        });
      },
    }),
  );
